import { ExtendedSubscription, Subscription, SubscriptionPlan, buyMessagesOption, MessageOption } from "@arelia-types/subscriptions";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { http } from "src/api/http";

export function useSubscriptionDetailsAPI(identityId: string | undefined) {
  return useQuery<Subscription>({
    queryKey: ["useSubscriptionDetails"],
    queryFn: () => http(identityId ? `/api/subscriptions/${identityId}` : `/api/subscriptions/my`)
  });
}

export function useUpdateSubscriptionAPI(identityId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: { name: SubscriptionPlan; endDate: string; }) => http(`/api/subscriptions/${identityId}`, {
      method: 'PUT',
      body,
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['useSubscriptionDetails']);
    }
  });
}

export function useUpdatePlanAPI(onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (planName: SubscriptionPlan) => http(`/api/subscriptions/reactivate?planName=${planName}`, {
      method: 'POST'
    }),
    onSuccess: (res) => {
      if (res) {
        window.location.href = res;
      } else {
        setTimeout(() => {
          queryClient.invalidateQueries(['useSubscriptionDetails']);
          onSuccess();
        }, 1000);
      }
    }
  });
}

export function useDowngradeToStarterAPI() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      http(`/api/subscriptions/reactivate?planName=Starter`, {
        method: 'POST'
      }),
    onSuccess: (res) => {
      if (res) {
        window.location.href = res;
      } else {
        queryClient.invalidateQueries(['useSubscriptionDetails']);

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    }
  });
}

export function useBuyMessagesAPI() {
  return useMutation({
    mutationFn: (option: buyMessagesOption) =>
      http("/api/subscriptions/buy-messages", {
        method: "POST",
        body: option,
      }),
    onSuccess: (res) => {
      if (res) {
        window.location.href = res;
      }
    }
  });
}

export function useMessageOptionsAPI() {
  return useQuery<MessageOption[]>({
    queryKey: ["messageOptions"],
    queryFn: () => http("/api/subscriptions/message-options")
  });
}

export function useSubscriptionManageUrl(onError: () => void) {
  return useMutation(
    () =>
      http(`/api/subscriptions/manage-url`, {
        method: "GET"
      }),
    {
      onSuccess: (response) => {
        const newTab = window.open(response, '_blank');
        newTab?.focus();
      },
      onError: onError
    }
  );
}

export function useSubscriptionDelete(identityId: string) {
  const queryClient = useQueryClient();

  return useMutation(
    (forcePaidRemoval: boolean = false) =>
      http(`/api/subscriptions/${identityId}/clear?forcePaidRemoval=${forcePaidRemoval}`, {
        method: "PUT"
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['useSubscriptionDetails']);
        queryClient.invalidateQueries(['useHqCustomerDetails']);
      },
    }
  );
}

export function useSubscriptionPlans() {
  return useQuery<ExtendedSubscription[]>({
    queryKey: ["useSubscriptionPlans"],
    queryFn: () => http(`/api/subscription-plans`)
  });
}